const ACTION_SHOW = 'loading-button/SHOW';
const ACTION_HIDE = 'loading-button/HIDE';

export function showSavingOnButton() {
  return {
    type: ACTION_SHOW,
  };
}

export function hideSavingOnButton() {
  return {
    type: ACTION_HIDE,
  };
}

export function savingButtonReducer(state = false, action) {
  switch (action.type) {
    case ACTION_SHOW: {
      return true;
    }
    case ACTION_HIDE: {
      return false;
    }
    default: {
      return state;
    }
  }
}
